import React, { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import SubmitButton from "./submit-button";
import PasswordInput from "./password-input";
import PasswordGreeting from "./password-greeting";
import { handleApiChangePassword } from "./handle-api";
import { validateInputs } from "./validators";
// import ShowErrors from "./show-errors";
import {
  FormContainer,
  ErrorArea,
  PassTextMessage,
  ErrorTextMessage,
} from "./settings.styles";

const ChangePassword = ({ user }) => {
  const [loading, setLoading] = useState(false);
  const [changePasswordFail, setChangePasswordFail] = useState({
    isFail: false,
    show: false,
    message: "     ",
  });
  const [changePasswordIn, setChangePasswordIn] = useState({
    oldPassword: "",
    password: "",
    passwordConfirm: "",
  });
  const [isInputValid, setIsInputValid] = useState({
    isOldPasswordValid: true,
    isPasswordValid: true,
    isPasswordConfirmValid: true,
  });

  const { oldPassword, password, passwordConfirm } = changePasswordIn;

  const handleInputChange = (e) => {
    setChangePasswordFail({
      show: false,
      isFail: false,
      message: "",
    });
    setIsInputValid({
      isOldPasswordValid: true,
      isPasswordValid: true,
      isPasswordConfirmValid: true,
    });
    setChangePasswordIn({
      ...changePasswordIn,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangePassword = async () => {
    const { oldPasswordValid, passwordValid, passwordConfirmValid } =
      validateInputs(changePasswordIn);

    setIsInputValid({
      isOldPasswordValid: oldPasswordValid,
      isPasswordValid: passwordValid,
      isPasswordConfirmValid: passwordConfirmValid,
    });
    if (!oldPasswordValid || !passwordValid || !passwordConfirmValid) {
      return;
    }
    setLoading(true);
    const result = await handleApiChangePassword({
      changePasswordIn: changePasswordIn,
    });
    setLoading(false);
    console.log("result is ", result);
    if (result === "passed") {
      setChangePasswordFail({
        isFail: false,
        show: true,
        message: "Your password has been changed",
      });
    } else {
      setChangePasswordFail({
        isFail: true,
        show: true,
        message: "Your password was not changed",
      });
    }
  };

  return (
    <FormContainer>
      <div className='p-fluid' id='register-form'>
        <PasswordGreeting email={user.email} />
        <PasswordInput
          password={oldPassword}
          handleChange={handleInputChange}
          isValid={isInputValid.isOldPasswordValid}
          pLabel='Current Password'
        />
        <PasswordInput
          password={password}
          handleChange={handleInputChange}
          isValid={isInputValid.isPasswordValid}
          pLabel='New Password'
        />
        <PasswordInput
          password={passwordConfirm}
          handleChange={handleInputChange}
          isValid={isInputValid.isPasswordConfirmValid}
          pLabel='Confirm New Password'
        />
        <SubmitButton
          buttonText='Save Changes'
          loading={loading}
          handleSubmit={handleChangePassword}
        />
        <ErrorArea>
          {changePasswordFail.show && changePasswordFail.isFail ? (
            <ErrorTextMessage>{changePasswordFail.message}</ErrorTextMessage>
          ) : (
            <PassTextMessage>{changePasswordFail.message}</PassTextMessage>
          )}
        </ErrorArea>
      </div>
    </FormContainer>
  );
};

// export default ChangePassword;

const mapStateToProps = (state) => ({
  user: state.user,
});

export default withRouter(connect(mapStateToProps, {})(ChangePassword));
